export default "__VITE_ASSET__Cwb4XHRx__"